import { useFlags } from 'launchdarkly-react-client-sdk'
import { formatSurgeryProviderName } from 'lib/utils/formatSurgeryProviderName'
import { TPatientInformationProps } from './PatientInformation.types'
import { useUser } from 'app/User'

export const usePatientInformationLogic = (props: TPatientInformationProps) => {
  const { surgery } = props
  const { isNurse } = useUser()
  const flags = useFlags()

  const showSurgeryType = flags.procedureListSurgeryType

  const patientDisplayName = `${
    surgery?.patient?.lastName
  }, ${surgery?.patient?.firstName?.charAt(0)}`
  const dateOfBirth = surgery?.patient?.dateOfBirth
  const medicalRecordNumber = surgery?.patient?.idMR
  const surgeryDescription = surgery?.procedures?.[0]?.description
  const surgeonName = formatSurgeryProviderName(surgery)

  return {
    flags,
    isNurse,
    dateOfBirth,
    surgeonName,
    showSurgeryType,
    patientDisplayName,
    medicalRecordNumber,
    surgeryDescription,
  }
}
